const doc = [({"da":({"js":({"admin":({"logs":({"details":({"reimbursement":({"update":({"changed_from_to":"%{attribute} blev ændret fra %{from} til %{to}."})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;